import { ApplicationRef, Component, inject, OnInit } from "@angular/core";
import { SvsModalService } from "@svs/angular";
import { SettingsStore } from "../../@core/state/settings.store";
import { TosModalComponent } from "./tos-modal.component";

@Component({
  selector: "app-tos-modal-opener",
  imports: [],
  template: ``,
})
export class TosModalOpenerComponent implements OnInit {
  private readonly settingsStore = inject(SettingsStore);
  private readonly modalService = inject(SvsModalService);

  private readonly appRef = ApplicationRef;

  ngOnInit(): void {
    console.log(this.appRef);
    if (!this.settingsStore.tosAccepted()) {
      this.modalService.open(TosModalComponent, { dismissable: false });
    }
  }
}
